import { storage } from '@itau-loans-www/utils'

import common from '../common/fgts'

const storageName = `${APP_NAME}_${BUILD_ENV}`

export default (key) => {
  const isNcor = storage.session.getItem(`${storageName}_leadData`)?.tracking
    ?.isNcor
  const partner = storage.session.getItem(`${storageName}_leadData`)?.partner

  const payloadsMap = {
    fgts: {
      custom_path: '/fgts/saque-aniversario/home',
      ...common(partner)
    },
    fgtsTelhaNorte: {
      custom_path: '/fgts/saque-aniversario/home',
      ...common(partner)
    },
    fgtsMagalu: {
      custom_path: '/fgts/saque-aniversario/home',
      ...common(partner)
    },
    assai: {
      custom_path: '/fgts/saque-aniversario/home',
      ...common(partner)
    },
    fgtsPirelli: {
      custom_path: '/fgts/saque-aniversario/home',
      ...common(partner)
    },
    fgtsCarrefour: {
      custom_path: '/fgts/saque-aniversario/home',
      ...common(partner)
    },
    fgtsCrediffato: {
      custom_path: '/fgts/saque-aniversario/home',
      ...common(partner)
    },
    fgtsAtacadao: {
      custom_path: '/fgts/saque-aniversario/home',
      ...common(partner)
    },
    proposal: {
      custom_path: '/fgts/saque-aniversario/dados-iniciais',
      ...common(partner)
    },
    smsCodeVerification: {
      custom_path: '/fgts/saque-aniversario/token',
      ...common(partner)
    },
    allowFgtsApp: {
      custom_path: '/fgts/saque-aniversario/elegivel/autorizacao-pendente',
      ...common(partner)
    },
    offers: isNcor
      ? {
          custom_path: 'fgts/saque-aniversario/oferta/nao-correntista',
          ...common(partner)
        }
      : {
          custom_path: 'fgts/saque-aniversario/oferta/correntista',
          ...common(partner)
        },
    offersDetails: isNcor
      ? {
          custom_path:
            '/fgts/saque-aniversario/oferta/nao-correntista/mais-detalhes',
          ...common(partner)
        }
      : {
          custom_path:
            '/fgts/saque-aniversario/oferta/correntista/mais-detalhes',
          ...common(partner)
        },
    pendingOfferError: {
      custom_path: '/fgts/saque-aniversario/proposta-pendente/erro',
      ...common(partner)
    },
    pendingOfferPhotoError: {
      custom_path: '/fgts/saque-aniversario/proposta-pendente/foto',
      ...common(partner)
    },
    pendingOfferFormalization: {
      custom_path:
        '/fgts/saque-aniversario/proposta-pendente/formalizacao-nao-finalizada',
      ...common(partner)
    },
    FormalizationPersonalDataFGTS: {
      custom_path:
        '/fgts/saque-aniversario/oferta/nao-correntista/dados-adicionais',
      ...common(partner)
    },
    FormalizationDocument: {
      custom_path: '/fgts/saque-aniversario/oferta/nao-correntista/documento',
      ...common(partner)
    },
    FormalizationAddress: {
      custom_path: '/fgts/saque-aniversario/oferta/nao-correntista/endereco',
      ...common(partner)
    },
    FormalizationBanking: {
      custom_path:
        '/fgts/saque-aniversario/oferta/nao-correntista/dados-bancarios',
      ...common(partner)
    },
    FormalizationFinished: {
      custom_path: '/fgts/saque-aniversario/oferta/nao-correntista/sucesso',
      ...common(partner)
    },
    resultadoFgtsIneligible: {
      custom_path: '/fgts/saque-aniversario/inelegivel',
      ...common(partner)
    },
    resultadoFgtsPartnerIneligible: {
      custom_path: '/fgts/saque-aniversario/inelegivel',
      ...common(partner)
    },
    AllowFgtsAppNotSuccess: {
      custom_path: '/fgts/saque-aniversario/elegivel/autorizacao-nao-detectada',
      ...common(partner)
    },
    resultadoFgtsWebAppSuccess: {
      custom_path:
        '/fgts/saque-aniversario/formalizacao/correntista/redirect-app',
      ...common(partner)
    }
  }

  return payloadsMap[key] ?? {}
}
